import React from 'react';
import { cn } from '../../lib/utils';
import { ArrowRight, Phone, Mail, MapPin, Calendar } from 'lucide-react';

export function Footer({ className, ...props }) {
  return (
    <footer
      className={cn(
        'border-t bg-white border-gray-200',
        className,
      )}
      {...props}
    >
      <div className="relative mx-auto max-w-7xl px-4">
        <div className="relative grid grid-cols-1 border-x border-gray-200 md:grid-cols-4 md:divide-x divide-gray-200">
          <div>
            <SocialCard title="Services" href="#services" />
            <LinksGroup
              title="Nos Services"
              links={[
                { title: 'Plomberie', href: '#services' },
                { title: 'Chauffage', href: '#services' },
                { title: 'Débouchage', href: '#services' },
                { title: 'Serrurerie', href: '#services' },
                { title: 'Urgences 24/7', href: '#contact' },
              ]}
            />
          </div>
          
          <div>
            <SocialCard title="Avantages" href="#avantages" />
            <LinksGroup
              title="Pourquoi Esiteck"
              links={[
                { title: 'Techniciens Certifiés', href: '#avantages' },
                { title: 'Devis Gratuit', href: '#contact' },
                { title: 'Prix Transparents', href: '#avantages' },
                { title: 'Garantie 5 ans', href: '#avantages' },
                { title: 'Équipement Moderne', href: '#avantages' },
              ]}
            />
          </div>
          
          <div>
            <SocialCard title="Zone d'Intervention" href="#zone-intervention" />
            <LinksGroup
              title="Belgique"
              links={[
                { title: 'Bruxelles', href: '#zone-intervention' },
                { title: 'Anvers', href: '#zone-intervention' },
                { title: 'Liège', href: '#zone-intervention' },
                { title: 'Gand', href: '#zone-intervention' },
                { title: 'Charleroi', href: '#zone-intervention' },
              ]}
            />
          </div>
          
          <div>
            <SocialCard title="Contact" href="#contact" />
            <LinksGroup
              title="Nous Contacter"
              links={[
                { title: '0465 19 57 26', href: 'tel:+32465195726' },
                { title: 'contact@esiteck.com', href: 'mailto:contact@esiteck.com' },
                { title: 'Avenue Louise 123', href: '#contact' },
                { title: 'Bruxelles', href: '#contact' },
                { title: '24h/24 - 7j/7', href: '#contact' },
              ]}
            />
          </div>
        </div>
      </div>
      
      <div className="flex flex-col md:flex-row justify-between items-center border-t border-gray-200 p-6 bg-gray-50">
        <div className="flex items-center mb-4 md:mb-0">
          <img 
            src="/SITECK.png" 
            alt="Esiteck - Plomberie & Chauffage" 
            className="h-16 w-auto"
          />
        </div>
        <p className="text-gray-500 text-xs text-center md:text-right">
          © {new Date().getFullYear()} Esiteck. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}

function LinksGroup({ title, links }) {
  return (
    <div className="p-4">
      <h3 className="text-blue-900 mt-2 mb-4 text-xs font-semibold tracking-wider uppercase">
        {title}
      </h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.title}>
            <a
              href={link.href}
              className="text-gray-600 hover:text-blue-900 text-sm transition-colors"
            >
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

function SocialCard({ title, href }) {
  return (
    <a
      href={href}
      className="hover:bg-blue-50 hover:text-blue-900 flex items-center justify-between border-t border-b border-gray-200 p-4 text-sm md:border-t-0 transition-colors"
    >
      <span className="font-semibold text-blue-900">{title}</span>
      <ArrowRight className="h-4 w-4 transition-colors text-blue-600" />
    </a>
  );
}